import { render, staticRenderFns } from "./AlertList.vue?vue&type=template&id=10f91d2b&"
import script from "./AlertList.vue?vue&type=script&lang=js&"
export * from "./AlertList.vue?vue&type=script&lang=js&"
import style0 from "./AlertList.vue?vue&type=style&index=0&id=10f91d2b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports